export default "__VITE_ASSET__bde48dbe__"